import React, { Component } from "react";
import { loading, mode, setDarkMode } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo-landscape.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Notfound extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    loading(false);
    if (mode === "dark") {
      setDarkMode();
    }
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
  }
  render() {
    return (
      <div className="w-100 min-vh-100 premium-report pp-scope">
        <div className="row mx-0">
          <div className="col-12 col-sm-11 col-md-9 col-xl-7 py-4 mx-auto">
            <div className="ar-hero mb-4">
              <img
                alt="logo"
                src={LOGO}
                height={34}
                style={{ objectFit: "contain" }}
                className="mb-3"
              />
              <div className="ar-eyebrow mb-1">Error</div>
              <div className="ar-title">404</div>
              <div className="ar-subtitle">
                Sorry, the webpage you requested was not found.
              </div>
            </div>
            <div className="p-5 text-center bg-white rounded-4 shadow-sm">
              <div className="mb-4">{window.location.href}</div>
              <button
                type="button"
                className="btn ar-btn-gold justify-content-center wpx-200 mt-3 mx-auto"
                onClick={() => {
                  localStorage.clear();
                  window.location.href = "/";
                }}
              >
                Return to the homepage
              </button>
              <div className="w-100 text-center mt-4">
                <small className="text-secondary">version {global.version}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
